import { useState, useEffect, useCallback, useContext } from 'react';
import { LoginContext } from '../../../App';
import { B2BContentContext } from '../../layout/Layout';
import { fetchRelatedDashboards } from '../../../services/b2b-reporting-apiServices';
import { showNotification } from '../../b2b-common/Notification';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const useDashboardsData = (areaIndicatorData) => {
    const { loginData } = useContext(LoginContext);
    const { setNotification } = useContext(B2BContentContext);
    const { t } = useB2BTranslation('b2b-plans');
    const [dashboardsData, setDashboardsData] = useState(null);

    const getDashboardsData = useCallback(async () => {
        if (loginData.productAcronyms.includes('B2B_CUSTOM_DASHBOARDS')) {
            try {
                const dashboards = await fetchRelatedDashboards(loginData.accessToken, "AREA_INDICATOR", areaIndicatorData);
                setDashboardsData(dashboards);
            } catch (error) {
                console.error('fetchRelatedDashboards error:', error);
                showNotification(setNotification, t('Error fetching dashboards: ') + error.message, 'error', 5000);
            }
        }
    }, [loginData.productAcronyms, loginData.accessToken, areaIndicatorData, setNotification, t]);

    useEffect(() => {
        if (loginData.productAcronyms.includes('B2B_CUSTOM_DASHBOARDS') && dashboardsData === null) {
            getDashboardsData();
        }
    }, [loginData.productAcronyms, dashboardsData, getDashboardsData]);

    return [dashboardsData, getDashboardsData];
};

export default useDashboardsData;